import { LeadPageType } from 'enums/leadPageTypes';
import { leadLazyLoad } from 'utils/loadable';

export const ReimbursementPage = leadLazyLoad(
  () => import('./ReimbursementRequest'),
  module => module.ReimbursementRequest,
  { fallback: null, type: LeadPageType.TIME_AND_PAY },
);
